export {
  StoreDetailsPage,
  StoreInformation,
  AboutStore,
  StoreServices,
  StoreAmenities
} from '../StoreDetailsPage'
